import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
  type Dispatch,
  type PropsWithChildren,
  type SetStateAction
} from 'react';
import UnsavedChangesModal from '../components/UnsavedChangesModal';

export interface IUnsavedChangesContext {
  link?: string;
  setLink: Dispatch<SetStateAction<string | undefined>>;
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  onSave?: () => void;
}

export const UnsavedChangesContext = createContext<
  IUnsavedChangesContext | undefined
>(undefined);

export const UnsavedChangesProvider: React.FC<PropsWithChildren> = ({
  children
}) => {
  const [link, setLink] = useState<string | undefined>(undefined);
  const [open, setOpen] = useState<boolean>(false);

  const context = useMemo(
    (): IUnsavedChangesContext => ({
      link,
      setLink,
      open,
      setOpen
    }),
    [link, setLink, open, setOpen]
  );

  return (
    <UnsavedChangesContext.Provider value={context}>
      {children}
    </UnsavedChangesContext.Provider>
  );
};

export function useUnsavedChanges() {
  const context = useContext(UnsavedChangesContext);
  if (context === undefined) {
    throw new Error(
      'useUnsavedChanges must be used within a UnsavedChangesProvider'
    );
  }

  // useEffect(() => {
  //   const handleBeforeUnload = (e: BeforeUnloadEvent) => {
  //     if (link !== undefined) {
  //       e.preventDefault();
  //       e.stopPropagation();
  //       e.returnValue = '';
  //     }
  //   };

  //   window.addEventListener('beforeunload', handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener('beforeunload', handleBeforeUnload);
  //   };
  // }, [link]);

  return context;
}
